import { format } from "date-fns";
import { Fragment, useState } from "react";
import useToken from "../useToken";
import { Button, ButtonGroup, Container, Spinner } from "react-bootstrap";
import { useGetInternetOrdersQuery } from "../../features/CallApi";


export const ReportsInternetOrders = () => {

    const [startDate, setStartDate] = useState(format(new Date(Date.now()), "dd.MM.yyyy"))
    // const [endDate, setEndDate] = useState(format(new Date(Date.now()), "dd.MM.yyyy"))
    const { token, role } = useToken();
    const [isDownload, setIsDownload] = useState(false)

    const { data, isLoading } = useGetInternetOrdersQuery(startDate)


    const downloadToExcel = () => {
        setIsDownload(true)
        fetch(`/api/ReportsService/get-internet-orders-to-excel?selEvenDate=${startDate}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }).then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `InternetOrdersToExecle${startDate}.xlsx`;
                link.click();
            })
            .catch(console.error);
        setIsDownload(false)
    }
    return (
        <div>
            <h3>Продажи на сайте по дате мероприятия</h3>
            <div>
                <div>
                    <div className="d-inline-flex mt-3 mb-3 input-group">
                        <div>
                            <div className="form-floating mb-1">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="startDate"
                                    name="startDate"
                                    onChange={
                                        (e) => {
                                            setStartDate(e.target.value)
                                        }
                                    }
                                    defaultValue={format((new Date(Date.now()) - 1), "yyyy-MM-dd")} />
                                <label htmlFor="startDate">Дата</label>
                            </div>
                            <div className="">
                                <Button
                                    variant="success"
                                    disabled={isDownload}
                                    onClick={() => { downloadToExcel() }}
                                >Сохранить в excel {isDownload && <Spinner />}</Button>
                            </div>
                        </div>
                        {/* <div>
                            <div className="form-floating">
                                <input
                                    type="datetime-local"
                                    className="form-control"
                                    id="endDate"
                                    name="endDate"
                                    onChange={
                                        (e) => {
                                            setEndDate(e.target.value)
                                        }
                                    }
                                    defaultValue={format(new Date(Date.now()), "yyyy-MM-dd") + "T23:59"} />
                                <label htmlFor="endDate">По</label>
                            </div>
                        </div> */}
                        <ButtonGroup className="ms-1">
                            {/* <Button className="text-white" color="success" onClick={() => { getItem() }}>Поиск</Button> */}
                            {/* <Button className="text-white" color="info" onClick={() => getReportExcelIgora()}>Сохранить в Excel</Button> */}
                            {/* <Button className="text-white" color="info" onClick={() => getReportOfClientsExcelNikolas()}>Сохранить в Excel</Button> */}
                        </ButtonGroup>

                    </div>
                </div>
            </div>
            <Container>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                Название шоу
                            </th>
                            <th>
                                Ф.И.О. гостя
                            </th>
                            <th>
                                Заказ №
                            </th>
                            <th>Ряд, (место)</th>
                            <th>Телефон</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? <>
                            {/* {!isLoading ? */}
                            <>
                                {data.map(item =>
                                    <Fragment key={item.eventName}>
                                        <tr>
                                            <td colSpan={5}>
                                                <strong>{item.eventName}</strong>
                                            </td>
                                        </tr>
                                        {item.orders.map(order =>
                                            <tr key={order.orderId}>
                                                <td></td>
                                                <td>{order.lastname} {order.firstname}</td>
                                                <td>{order.orderId}</td>
                                                <td>{order.places}</td>
                                                <td>{order.phone}</td>
                                            </tr>
                                        )}
                                    </Fragment>
                                )
                                }
                            </>
                            {/* : <LoadScreen />} */}
                        </>
                            :
                            <tr><td colSpan={11} className="text-center mt-5 mb-5"><strong>Список пуст</strong></td></tr>
                        }
                    </tbody>
                </table>
            </Container>
        </div>
    )
}